<script>
import router from "@/router";

export default {
  name: "redirect",
  created() {
    this.changeLanguage()
    this.redirect()
  },

  methods: {
    isMobile() {
      let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
      return flag;
    },
    redirect() {
      // 获取当前路由
      let path = this.$route.fullPath
      const pcPath = "/pc"
      const phonePath = "/phone"
      if (this.isMobile()) {
        path = phonePath + path
      } else {
        path = pcPath + path
      }
      this.$router.replace(path)
    },
    changeLanguage() {
      if (Object.keys(this.$i18n.messages).includes(this.$route.query.lang)) {
        this.$i18n.locale = this.$route.query.lang
        this.$store.commit('changeLanguage', this.$route.query.lang)
      } else {
        // 判断之前是否有语言
        if (this.$store.state.language === '') {
          this.$i18n.locale = navigator.language.replace(/-/g, '_')
        } else {
          this.$i18n.locale = this.$store.state.language
        }
      }
    },
  }
}
</script>

<template>
  <router-view/>
</template>

<style scoped>

</style>